import { Trans, useTranslation } from 'react-i18next';

import ConfirmModal from 'src/components/email-builder/components/ConfirmModal';
import { useStopAbTestConfigMutation } from 'src/services/agent-ab-test/agentAbTestApi';
import {
  SolveABTestConfig,
  SolveABTestConfigSummary,
} from 'src/services/agent-ab-test/types';
import { setGlobalToastOptions } from 'src/slices/ui/uiSlice';
import { useAppDispatch } from 'src/store/hooks';

interface StopAbTestConfirmModalProps {
  abTestConfig: SolveABTestConfigSummary | SolveABTestConfig;
  onClose: () => void;
}

const StopAbTestConfirmModal = ({
  abTestConfig,
  onClose,
}: StopAbTestConfirmModalProps) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('agent-ab-test');
  const [stopAbTestConfig, { isLoading: isStopping }] =
    useStopAbTestConfigMutation();

  return (
    <ConfirmModal
      actions={[
        {
          onClick: onClose,
          title: t('stopDialog.cancelButton'),
        },
        {
          isLoading: isStopping,
          onClick: async () => {
            try {
              await stopAbTestConfig(abTestConfig.ab_test_config_id).unwrap();

              dispatch(
                setGlobalToastOptions({
                  autoHideDuration: 5000,
                  title: t('toast.stopped', { name: abTestConfig.name }),
                  variant: 'main',
                }),
              );

              onClose();
            } catch {
              dispatch(
                setGlobalToastOptions({
                  autoHideDuration: 5000,
                  title: t('toast.stopFailed', { name: abTestConfig.name }),
                  variant: 'danger',
                }),
              );
            }
          },
          title: t('stopDialog.confirmButton'),
        },
      ]}
      description={
        <>
          <p>
            <Trans
              i18nKey='stopDialog.body1'
              ns='agent-ab-test'
              values={{ name: abTestConfig.name }}
            />
            <br />
            {t('stopDialog.body2')}
            <br />
            {t('stopDialog.body3')}
          </p>
        </>
      }
      isOpen={true}
      onClose={onClose}
      title={t('stopDialog.title')}
    />
  );
};

export default StopAbTestConfirmModal;
